export default __webpack_public_path__ + "static/media/illustrator.33feff48.svg";